var en_IE = {};
module['exports'] = en_IE;
en_IE.title = "English (Ireland)";
en_IE.address = require("./address");
en_IE.internet = require("./internet");
en_IE.phone_number = require("./phone_number");
en_IE.cell_phone = require("./cell_phone");